export default "__VITE_ASSET__DRJALS5b__"